import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ToasterProps } from "#ui/types";

const purple = "\x1b[35m";
const pastelRed = "\x1b[91m";
const reset = "\x1b[0m";


export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

useHead({
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
  ],
  link: [{ rel: "icon", href: "/favicon.ico" }],
  htmlAttrs: {
    lang: "en",
  },
});

const toaster = {
  position: "bottom-right",
  duration: 7000,
  orientation: "horizontal",

  close: {
    color: "neutral",
    variant: "ghost",
  },
} as ToasterProps;

if (import.meta.client) {
  console.log(
    purple +
      "░█▀▀░█▀█░█▄█░▀█▀░█░░░█░█" +
      pastelRed +
      "░█▀█░█░█░▀█▀░█▀▀" +
      reset +
      "\n" +
      purple +
      "░█▀▀░█▀█░█░█░░█░░█░░░░█░" +
      pastelRed +
      "░█▀█░▄▀▄░░█░░▀▀█" +
      reset +
      "\n" +
      purple +
      "░▀░░░▀░▀░▀░▀░▀▀▀░▀▀▀░░▀░" +
      pastelRed +
      "░▀░▀░▀░▀░▀▀▀░▀▀▀ ©" +
      reset,
  );
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLoadingIndicator = _resolveComponent("NuxtLoadingIndicator")!
  const _component_NuxtPage = _resolveComponent("NuxtPage")!
  const _component_NuxtLayout = _resolveComponent("NuxtLayout")!
  const _component_UApp = _resolveComponent("UApp")!

  return (_openBlock(), _createBlock(_component_UApp, { toaster: toaster }, {
    default: _withCtx(() => [
      _createVNode(_component_NuxtLoadingIndicator, {
        color: "indigo",
        height: 5
      }),
      _createVNode(_component_NuxtLayout, null, {
        default: _withCtx(() => [
          _createVNode(_component_NuxtPage)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})